class VariantSelects extends HTMLElement {
  constructor() {
    super()

    this.uxUnavailableVariantButtons = document
      .querySelector('section[data-unavailable-variant-buttons]')
      .getAttribute('data-unavailable-variant-buttons')

    // console.warn(!!this.uxUnavailableVariantButtons)

    this.allOptions = JSON.stringify(
      this.getVariantData().map(({ options }) => options)
    )

    // console.table(this.allOptions)

    this.fieldSets = document.querySelectorAll(
      'fieldset.product-form__input:not(.product-form__quantity)'
    )

    // console.log(this.fieldSets)

    this.fieldSetsSelected = {
      0: '',
      1: '',
      2: '',
    }

    this.templateType = document
      .querySelector('section[data-template-type]')
      .getAttribute('data-template-type')

    this.step = 1
    this.productMedia = document.querySelectorAll(
      '.product__media-item .product__media > img'
    )
    this.productMediaModal = document.querySelectorAll(
      '.product-media-modal__content > img'
    )

    // Get all option1 values and create a unique array
    this.pods = [
      ...new Set(this.getVariantData().map(({ option1 }) => option1)),
    ]

    if (!!this.uxUnavailableVariantButtons) this.disableVariantButtons()

    if (window.location.search) {
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)
      // console.log(urlParams.has('variant'))
      if (urlParams.has('variant')) {
        const variandId = parseInt(urlParams.get('variant'))

        this.previousPod = this.getVariantData().filter(
          ({ id }) => id === variandId
        )[0].option1
        this.selectedPod = this.getVariantData().filter(
          ({ id }) => id === variandId
        )[0].option1
      }
    } else {
      this.previousPod = this.pods[0]
      this.selectedPod = this.pods[0]
    }

    if (this.templateType === 'join') this.hideImages()

    this.addEventListener('change', this.onVariantChange)
  }

  disableVariantButtons() {
    if (!this.fieldSets) return

    // 1. Set fieldset currently selected value (Pod type, Vest type and Size)
    this.fieldSets.forEach((item, index) => {
      item.querySelectorAll('input').forEach((input) => {
        if (input.checked) {
          this.fieldSetsSelected[index] = input.value
        }
      })
    })

    // 2. Set custom data-option-choice attribute on each label
    this.fieldSets.forEach((item, index) => {
      this.setLabelAttribute(item, index, this.fieldSets.length)
    })

    // 3.
    const handler = (item) => {
      item.querySelectorAll('label').forEach((label) => {
        label.classList.remove('disable-variant-button')

        const current = JSON.stringify(
          label.getAttribute('data-option-choice').split(',')
        )

        const result = this.allOptions.indexOf(current)
        if (result !== -1) {
          // console.log('exists')
        } else {
          // console.log(label.getAttribute('data-option-choice'), 'does not exist')
          label.classList.add('disable-variant-button')
        }
      })
    }

    if (this.fieldSets.length === 3) {
      handler(this.fieldSets[2])
    } else {
      this.fieldSets.forEach((item, index) => {
        if (index === 0) return
        handler(item)
      })
    }
  }

  setLabelAttribute(fieldSet, targetIndex = 2, length = 3) {
    if (!fieldSet instanceof Element) return

    const optionArray = (label) => {
      let newArray = []

      for (let index = 0; index < length; index++) {
        if (index === targetIndex) {
          newArray[index] = label.previousElementSibling.value
        } else {
          newArray[index] = this.fieldSetsSelected[index]
        }
      }
      // console.log(newArray)
      return newArray
    }

    fieldSet.querySelectorAll('label').forEach((label) => {
      label.setAttribute('data-option-choice', optionArray(label))
    })
  }

  clearImages() {
    this.productMedia.forEach((item) =>
      item.closest('li').classList.remove('hidden')
    )

    this.productMediaModal.forEach((item) => item.classList.remove('hidden'))
  }

  hideImages() {
    // product gallery list
    const hideImages = Array.from(this.productMedia).filter(
      (item) => !item.alt.includes(this.selectedPod)
    )
    hideImages.forEach((image) => {
      const parent = image.closest('li')
      parent.classList.add('hidden')
    })

    // modal
    const hideModalImages = Array.from(this.productMediaModal).filter(
      (item) => !item.alt.includes(this.selectedPod)
    )
    hideModalImages.forEach((image) => {
      image.classList.add('hidden')
    })
  }

  onVariantChange() {
    if (!!this.uxUnavailableVariantButtons) this.disableVariantButtons()
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    this.clearImages()
    // this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.selectedPod = this.currentVariant.option1

      this.updateMedia()
      if (this.templateType === 'join') this.hideImages()
      this.updateURL()
      this.updateVariantInput()
      this.renderProductInfo()
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    )
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    )
    if (!newMedia) return
    // const parent = newMedia.parentElement
    // parent.prepend(newMedia)

    // window.setTimeout(() => {
    //   parent.scroll({
    //     top: 0,
    //     left: 0,
    //   })
    // })
  }

  updateURL() {
    if (!this.currentVariant) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id)
        const source = html.getElementById(id)

        if (source && destination) destination.innerHTML = source.innerHTML

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove('visibility-hidden')
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        )
      })
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')

    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', true)
      if (text) addButton.textContent = text
    } else {
      addButton.removeAttribute('disabled')
      addButton.textContent = window.variantStrings.addToCart
    }

    if (!modifyClass) return
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')
    if (!addButton) return
    addButton.textContent = window.variantStrings.unavailable
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add('visibility-hidden')
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }

  getImagesOffsetTop() {
    const imagesOffsetTop = []
    const images = Array.from(
      document.querySelectorAll('.product__media-item')
    ).filter((image) => !image.classList.contains('hidden'))

    images.forEach(function (image) {
      imagesOffsetTop.push(image.offsetTop)
    })

    return imagesOffsetTop
  }

  scrollProductImage() {
    // console.log('scrollProductImage()')
    if (window.innerWidth < 990) return

    const offsetTop = this.getImagesOffsetTop()
    const productMediaList = document.querySelector('.product__media-list')

    productMediaList.scroll({
      top: offsetTop[this.step],
      behavior: 'smooth',
    })
    this.step < offsetTop.length - 1 ? this.step++ : (this.step = 0)
  }
}

customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
  constructor() {
    super()
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value
    })
  }
}

customElements.define('variant-radios', VariantRadios)
